import template from './report_company_leave_available_adjust_and_refresh.html';
import tr from '../../lib/default-translator.js';

class ReportCompanyLeaveAvailableAdjustDateViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.on_date = ko.observable();
		this.reset_settings = ko.observable(false);
	};

	close()
	{
		this.dialog.close();
	}

	async save_date_and_refresh()
	{
		let obj = {
			on_date: this.on_date(),
			reset_to_default: this.reset_settings()
		};

		if (moment(obj.on_date).isValid() == false && obj.reset_to_default == false)
		{
			Grape.alerts.alert({ type: 'error', message: tr('Your date is not valid.'), title: tr('Error', 'Error') });
			return;
		}

		let res = await Grape.fetches.postJSON('/reports/leave_available_report_set_date_and_refresh', obj);
		
		if (res.status == 'OK') {
			Grape.alerts.alert({type: 'success', message: tr('Successfully set report settings. The report is being generated. Please refresh this page at a later stage to see the completed report.'), title: tr('Success', 'Success')});
			this.dialog.close(); 
		} 
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else if (res.error)
			Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error', 'Error') });
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};
};

class ReportCompanyLeaveAvailableAdjustDatePage
{
	constructor (bindings)
	{
		this.viewModel = new ReportCompanyLeaveAvailableAdjustDateViewModel(this);
		this.bindings = bindings;
	};

	init()
	{};
};

export default {
	name: 'ReportCompanyLeaveAvailableAdjustDate',
	dialog_class: ReportCompanyLeaveAvailableAdjustDatePage,
	template: template,
	template_filename: 'translation/dialogs/report_company_leave_available_adjust_and_refresh',
	provider: 'ps'
};
